import React, { useState } from 'react'
import style from "../pendingApproval/pending.module.css";

const BoxComponent = () => {
  return(
    <div className={style.padding}>
    <div className={style.gridForm}>

      <div className="d-flex">
        <span className={style.squareIcon}>P</span>
        <p>Prescription</p>
      </div>

      <div className="d-flex">
        <span className={style.squareIcon}>L</span>
        <p>Lab reports</p>
      </div>

    </div>

  <div className={style.gridForm}>

    <div className="d-flex">
      <span className={style.squareIcon}>M</span>
      <p>Medical notes</p>
    </div>

    <div className="d-flex">
      <span className={style.squareIcon}>I</span>
      <p>Imaging</p>
    </div>

  </div>
    </div>
  )
}
export default BoxComponent
